import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FS } from "src/configs/constance";
import DilutionStakingContract from "src/contract-logic/logic/DilutionStakingContract";
import multiCall from "src/utils/multicall";
import DilutionStakingQuery from "src/utils/query/onchain/multi-call-query/dilution-staking-query";

const initialState = {
  yourBattlefield: {},
  limitedArmy: {},
  fetchYourBattlefieldStatus: FS.INITIAL,
  fetchLimitedArmyStatus: FS.INITIAL,
};

export const fetchYourBattlefield = createAsyncThunk("dilutionStaking/fetchYourBattlefield", async (_, thunkAPI) => {
  const accountAddress = thunkAPI.getState().accountSlice.address;
  thunkAPI.dispatch(dilutionStakingSlice.actions.setDilutionStatus({ type: "battlefield", status: FS.FETCHING }));
  const battleLength = await DilutionStakingContract.balanceOf(accountAddress);
  const [battleIds] = await Promise.all([
    multiCall(
      DilutionStakingContract.ABI,
      new Array(battleLength).fill(1).map((_, index) => ({
        address: DilutionStakingContract.ADDRESS,
        name: "tokenOfOwnerByIndex",
        params: [accountAddress, index],
      }))
    ),
  ]);
  const battleIdsFlattened = battleIds.flat();
  const data = await DilutionStakingQuery.fetchArmyList(battleIdsFlattened);
  return data;
});

export const fetchDetailArmy = createAsyncThunk("dilutionStaking/fetchDetailArmy", async ({ armyId }, thunkAPI) => {
  thunkAPI.dispatch(dilutionStakingSlice.actions.setDilutionStatus({ type: "battlefield", status: FS.FETCHING }));
  const data = await DilutionStakingQuery.fetchDetailArmy(armyId);
  return { armyId: armyId, data };
});

export const fetchLimitedArmy = createAsyncThunk("dilutionStaking/fetchLimitedArmy", async (_, thunkAPI) => {
  thunkAPI.dispatch(dilutionStakingSlice.actions.setDilutionStatus({ type: "limited", status: FS.FETCHING }));
  const data = await DilutionStakingQuery.fetchLimitedArmy();
  return data;
});

const dilutionStakingSlice = createSlice({
  name: "dilutionStakingSlice",
  initialState: initialState,
  reducers: {
    setDilutionStatus(state, action) {
      const type = action.payload.type;
      if (type == "battlefield") state.fetchYourBattlefieldStatus = action.payload.status;
      else if (type == "limited") state.fetchLimitedArmyStatus = action.payload.status;
    },
    removeBattlefield(state, action) {
      const armyId = action.payload.armyId;
      delete state.yourBattlefield[armyId];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchYourBattlefield.fulfilled, (state, action) => {
        state.yourBattlefield = action.payload;
        state.fetchYourBattlefieldStatus = FS.SUCCESS;
      })
      .addCase(fetchYourBattlefield.rejected, (state, action) => {
        console.error(action);
        state.fetchYourBattlefieldStatus = FS.FAIL;
        state.yourBattlefield = {};
      })
      .addCase(fetchDetailArmy.fulfilled, (state, action) => {
        const armyId = action.payload.armyId;
        state.yourBattlefield[armyId] = action.payload.data;
        state.fetchYourBattlefieldStatus = FS.SUCCESS;
      })
      .addCase(fetchDetailArmy.rejected, (state, action) => {
        console.error(action);
        state.fetchYourBattlefieldStatus = FS.FAIL;
        state.yourBattlefield = {};
      })
      .addCase(fetchLimitedArmy.fulfilled, (state, action) => {
        state.limitedArmy = action.payload;
        state.fetchLimitedArmyStatus = FS.SUCCESS;
      })
      .addCase(fetchLimitedArmy.rejected, (state, action) => {
        console.error(action);
        state.fetchLimitedArmyStatus = FS.FAIL;
        state.limitedArmy = {};
      });
  },
});

export default dilutionStakingSlice.reducer;
export const { removeBattlefield } = dilutionStakingSlice.actions;
